import ShPopConfirm from '@/components/Helpers/ShPopConfirm';
import AgentsBelongsToGroupList from './AgentsBelongsToGroupList';

// @vue/component
export default {
  name: 'IvrProjectAgentGroupsListItem',

  components: {
    ShPopConfirm,
    AgentsBelongsToGroupList,
  },

  props: {
    group: {
      type: Object,
      default: () => ({}),
    },
    projectUuid: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isModalVisible: false,
      isEditingMode: false,
      editedName: null,
    };
  },

  methods: {
    showAgentsBelongsToGroupList() {
      this.isModalVisible = true;
    },
    async handleRemoveGroup() {
      const params = {
        group: this.group.uuid,
        project: this.projectUuid,
      };

      await this.$store.dispatch('client/project/agentsGroups/removeGroup', params);
      this.$store.dispatch('client/project/agentsGroups/getList', this.projectUuid);
      this.$message({
        message: `Pomyślnie usunięto grupę:${this.group.name}`,
        type: 'success',
      });
    },
    toggleEditiingMode() {
      this.isEditingMode = !this.isEditingMode;

      if (this.isEditingMode) {
        this.editedName = this.group.name;
      }
    },
    async submitUpdateGroupName() {
      const params = {
        name: this.editedName,
        group: this.group.uuid,
        project: this.projectUuid,
      };
      await this.$store.dispatch('client/project/agentsGroups/updateGroup', params);
      this.$message({
        type: 'success',
        message: `Pomyślnie zmieniono nazwę grupy${this.group.name} na ${this.editedName}`,
      });
      this.$store.dispatch('client/project/agentsGroups/getList', this.projectUuid);
    },
  },
};
